import { useQuery } from "react-query";
import { getCameraSystemList } from "../../../../../actions/Utilities/CameraSystem";

export default function useGetCameraSystemList() {
  return useQuery("GetCameraSystem", getCameraSystemList, {
    refetchOnWindowFocus: false,
  });
}
